import React from 'react'
import { useTranslation } from 'react-i18next'
import { faCalendarClock } from '@fortawesome/pro-regular-svg-icons'

import { FaIcon } from '../../../App/Components'
import { CustomerPunchCard } from '../../types'
import {
  PunchCardBlock,
  PunchCardBlockHeader,
  PunchCardCard,
  PunchCardName,
  PunchCardDescription,
  PunchCardDetails,
  PunchCardDetailItem,
  PunchCardDetailText,
} from './style'

type Props = {
  cards: CustomerPunchCard[]
  highlightColor: string
  fontColor: string
}

export const PunchCardConfirmBlock = ({
  cards,
  highlightColor,
  fontColor,
}: Props) => {
  const { t } = useTranslation()

  if (!cards || cards.length === 0) return null

  return (
    <PunchCardBlock highlightcolor={highlightColor}>
      <PunchCardBlockHeader fontcolor={fontColor}>
        {t('Used Punch Card')}
      </PunchCardBlockHeader>
      {cards.map((card) => (
        <PunchCardCard key={card.uuid}>
          <PunchCardName fontcolor={fontColor}>{card.name}</PunchCardName>
          {card.activity && (
            <PunchCardDescription fontcolor={fontColor}>
              {card.activity.name}
            </PunchCardDescription>
          )}
          <PunchCardDetails>
            {card.expires_at && (
              <PunchCardDetailItem>
                <FaIcon size="xs" icon={faCalendarClock} color={fontColor} />
                <PunchCardDetailText fontcolor={fontColor}>
                  {new Date(card.expires_at).toLocaleDateString()}
                </PunchCardDetailText>
              </PunchCardDetailItem>
            )}
            <PunchCardDetailItem style={{ marginLeft: 'auto' }}>
              <PunchCardDetailText fontcolor={fontColor}>
                # {card.turns.left}/{card.turns.initial}
              </PunchCardDetailText>
            </PunchCardDetailItem>
          </PunchCardDetails>
        </PunchCardCard>
      ))}
    </PunchCardBlock>
  )
}
